export function obterListaTipoPintura() {
  return (
    [
      { label: 'Sólida', value: 'SOLIDA' },
      { label: 'Metálica', value: 'METALICA' },
      { label: 'Perolizada', value: 'PEROLIZADA' },
    ]
  );
}
